import React from "react";
import PropTypes from "prop-types";
import styles from "./CheckedInItem.module.css";
import { useTranslation } from "react-i18next";

export function CheckedInItem({ date, time }) {
  const {t} = useTranslation();
  return (
    <div className={styles.checkedInItem}>
      {t("Checked In")} {date}, {time}
    </div>
  );
}

CheckedInItem.propTypes = {
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};
